import {connect} from 'react-redux';
import DirectionsOrExternalURLQRCodeComponent from './DirectionsOrExternalURLQRCodeComponent';

const mapStateToProps = state => ({
    isSearchingRoute: state.pageState.explorerMap.isSearchingRoute,
    pathFound: state.pageState.explorerMap.pathFound,
    nightSafePathSearch: state.pageState.explorerMap.nightSafePathSearch,
    selectedRouteOption: state.pageState.explorerMap.selectedRouteOption,
});

export default connect(mapStateToProps)(DirectionsOrExternalURLQRCodeComponent);
